var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _ellipse, _ellipse2, _ellipse3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle2, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgICanFly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 237,
    viewBox: "0 0 1030.57471 696.9775",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i can fly") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M831.93752,263.72788a60.64529,60.64529,0,0,1,60.56127-57.47579c1.84313,0,3.66317.09612,5.46442.25711a80.5744,80.5744,0,0,1,139.28388-.06586c1.51962-.11413,3.04946-.19125,4.59825-.19125a60.6453,60.6453,0,0,1,60.56127,57.47579",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5686,259.06279A60.64529,60.64529,0,0,1,905.12987,201.587c1.84313,0,3.66317.09612,5.46442.25711a80.5744,80.5744,0,0,1,139.28388-.06586c1.51962-.11413,3.04946-.19125,4.59825-.19125a60.6453,60.6453,0,0,1,60.56127,57.47579",
    transform: "translate(-84.96231 -101.26125)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.9876,605.48825c5.45455-105.97956,93.1087-190.23237,200.44463-190.23237,6.10037,0,12.12431.31815,18.08607.851a266.68374,266.68374,0,0,1,460.99935-.218c5.0296-.37777,10.093-.633,15.21919-.633,107.33593,0,194.99008,84.25281,200.44463,190.23237",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.79373,590.04781c5.45455-105.97956,93.1087-190.23237,200.44464-190.23237,6.10036,0,12.1243.31815,18.08606.851a266.68374,266.68374,0,0,1,460.99935-.21795c5.0296-.37777,10.093-.633,15.21919-.633,107.33593,0,194.99009,84.25281,200.44463,190.23237",
    transform: "translate(-84.96231 -101.26125)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.96231,239.72788a82.05654,82.05654,0,0,1,81.94283-77.768c2.49387,0,4.95648.13007,7.39368.34789a109.02172,109.02172,0,0,1,188.459-.0891c2.05613-.15444,4.12609-.25879,6.22169-.25879a82.05654,82.05654,0,0,1,81.94283,77.768",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.05288,233.41575a82.05654,82.05654,0,0,1,81.94283-77.768c2.49386,0,4.95648.13007,7.39368.34788a109.02173,109.02173,0,0,1,188.459-.0891c2.05613-.15443,4.12609-.25878,6.22169-.25878a82.05654,82.05654,0,0,1,81.94283,77.768",
    transform: "translate(-84.96231 -101.26125)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M495.9876,336.92106s14,34-7,42c0,0,30,13,37,10s12-10,12-12-7-3-7-3-13,1-3-32Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#fbbebe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 427.02529,
    cy: 228.65981,
    r: 25,
    fill: "#fbbebe"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.52529,
    cy: 223.15981,
    rx: 22,
    ry: 31,
    fill: "#ff6584"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.52529,
    cy: 213.15981,
    rx: 22,
    ry: 31,
    fill: "#ff6584"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.52529,
    cy: 190.65981,
    rx: 11,
    ry: 15.5,
    fill: "#ff6584"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M536.9876,372.92106s6-12,28-18,65-78,65-78-2-43,8-30,2,39,2,39l-25.80418,44.57085a97.08358,97.08358,0,0,1-17.8724,22.42615c-15.95376,14.84942-44.459,41.003-47.32342,41.003C544.9876,393.92106,536.9876,372.92106,536.9876,372.92106Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#fbbebe"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M501.9876,543.92106s7,85,5,93-8,24,2,71-2,44-2,44l32,14s-11-54-9-69,1-46,7-67,7-80,7-80Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#fbbebe"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M501.9876,543.92106s7,85,5,93-8,24,2,71-2,44-2,44l32,14s-11-54-9-69,1-46,7-67,7-80,7-80Z",
    transform: "translate(-84.96231 -101.26125)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M537.74261,755.1021c-2.47934,1.72219-8.84818,3.47-20.755-9.181,0,0-7-10-13,0s-2,11,2,16c3.86133,4.82665,34.74673,37.60925,47.6783,36.27827a6.16621,6.16621,0,0,0,1.3217-.27827c12-4-5-17-5-17s-11.14536-17.14671-11.20891-25.24382A.66759.66759,0,0,0,537.74261,755.1021Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M477.9876,533.92106s-17,39-24,59c-3.675,10.5-14.79187,13.83375-24.52373,14.63175a83.87385,83.87385,0,0,0-34.26925,10.32726c-13.99626,7.85614-33.09469,16.77132-45.207,15.041-21-3-4,30-4,30s31-19,60-21,60-5,74-23,48-75,48-75Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#fbbebe"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M346.9876,657.92106s-10-7-2-14,11-13,11-13-14-15-19-7-27,44-22,55,10,14,16,2,21.13216-21.44741,21.13216-21.44741Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M532.9876,377.92106s-3.32428,6.64857-34.217.24731a18.97584,18.97584,0,0,0-20.908,9.75269c-3.875,7.75-4.375,19,9.125,33,0,0,24,27,12,38s57-7,57-7-9-6-1-24c6.28572-14.14286,5.78061-22.11225.91-28.27369a30.88363,30.88363,0,0,1-5.83871-13.04832c-1.36549-6.69413-4.73864-15.08281-13.07128-15.678,0,0-8.75922-.513-9.37961,1.74348S534.9876,376.92106,532.9876,377.92106Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#428591"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M496.42583,399.13443c-.20653-1.4101-.45929-2.81119-.63632-4.2253-.60438-4.82791-2.89964-16.52583-10.84061-14.513-9.9613,2.52494-20.9613,27.52494-20.9613,27.52494s-9,28-22,35-49,43-49,43-30,8-19,16,25-5,25-5L434.3561,475.7a101.249,101.249,0,0,0,31.196-29.33114c7.36824-10.67142,16.59508-23.00458,22.442-27.07969a19.27945,19.27945,0,0,0,7.55716-9.8792A22.9342,22.9342,0,0,0,496.42583,399.13443Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#fbbebe"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M504.9876,456.92106s-46-6-72,25-45,22-43,27,98,64,154,57c34.0927-4.26159,52.24808-8.15254,61.23541-10.54465a17.445,17.445,0,0,0,9.64045-6.46652,17.70419,17.70419,0,0,1,4.8741-4.4263,8.65554,8.65554,0,0,0,2.32826-12.21235c-15.85981-22.94586-58.91668-83.72865-71.07822-85.35018C535.9876,444.92106,504.9876,456.92106,504.9876,456.92106Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#428591"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.52529,
    cy: 201.65981,
    rx: 16,
    ry: 11.5,
    fill: "#ff6584"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M831.80443,200.44953a113.38769,113.38769,0,0,1,4.17018-15.5535c1.80736-4.94254,4.09325-9.15909,6.64158-9.15909,6.17815,0-21.62352-26.25714-21.62352-26.25714s-1.74515,3.24349-4.63361,7.61456a107.69871,107.69871,0,0,1-6.9195,9.42164,51.65324,51.65324,0,0,1-11.615,10.76547C785.46831,185.00416,831.80443,200.44953,831.80443,200.44953Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#a0616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M913.60129,302.8337s61.93712,39.13288,42.853,45.5631-50.70024-39.54394-50.70024-39.54394Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#a0616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M830.5248,213.9466s29.66413,21.631,38.33346,38.08562,53.7408,53.01994,53.7408,53.01994-9.30555,18.38594-13.80443,17.2767S811.544,252.21811,801.786,246.63065,806.90049,206.53108,830.5248,213.9466Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#428591"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M830.5248,213.9466s29.66413,21.631,38.33346,38.08562,53.7408,53.01994,53.7408,53.01994-9.30555,18.38594-13.80443,17.2767S811.544,252.21811,801.786,246.63065,806.90049,206.53108,830.5248,213.9466Z",
    transform: "translate(-84.96231 -101.26125)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M918.29852,252.9638s69.50418,23.16806,52.51427,33.97982-58.69242-26.25713-58.69242-26.25713Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#a0616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M873.50694,569.59394s29.34621-12.35629,26.25713,6.17815-16.98991,35.52436-16.98991,44.79158-26.25713,29.34621-30.89075,24.7126,7.72269-23.16806,4.63362-33.97982-6.17815-35.52436-6.17815-35.52436Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#55536e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M873.50694,569.59394s29.34621-12.35629,26.25713,6.17815-16.98991,35.52436-16.98991,44.79158-26.25713,29.34621-30.89075,24.7126,7.72269-23.16806,4.63362-33.97982-6.17815-35.52436-6.17815-35.52436Z",
    transform: "translate(-84.96231 -101.26125)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M864.23971,583.49478s29.34621-12.3563,26.25714,6.17815-16.98991,35.52436-16.98991,44.79158-26.25714,29.34621-30.89075,24.7126,7.72269-23.16806,4.63361-33.97982-6.17815-35.52436-6.17815-35.52436Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#55536e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M796.28007,470.74356s91.1277,86.49409,88.03863,94.21677-23.16806,24.7126-23.16806,24.7126S791.64646,498.54523,796.28007,470.74356Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M796.28007,470.74356s91.1277,86.49409,88.03863,94.21677-23.16806,24.7126-23.16806,24.7126S791.64646,498.54523,796.28007,470.74356Z",
    transform: "translate(-84.96231 -101.26125)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M774.65655,314.74529s23.16806,23.16806,16.98991,67.95964,4.63361,88.03863,16.98991,101.93946,63.326,94.21678,63.326,94.21678-21.62352,35.52435-38.61343,16.98991-67.95964-94.21678-67.95964-94.21678S719.05321,410.5066,714.4196,385.794s-6.17815-63.326,6.17815-71.04872S774.65655,314.74529,774.65655,314.74529Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M812.96108,161.97511c18.04019,3.73778,16.24853,4.46371,27.33831,8.356.06178-.18535.12356-.3398.18534-.49426,1.699-4.04668,2.76472,1.26653,5.22054,1.26653,6.17814,0-21.62353-26.25714-21.62353-26.25714s-1.05028,1.94612-2.85739,4.86529c-.54059.8495-1.12751,1.77622-1.77622,2.74928-.54059.8186-1.12751,1.68355-1.74533,2.57938Z",
    transform: "translate(-84.96231 -101.26125)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.74295,
    cy: 52.85217,
    r: 29.34621,
    fill: "#a0616a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M791.64646,175.73694s44.79158,4.63361,54.05881,24.71259-57.14788,117.38484-61.7815,118.92937-69.50417,9.26723-69.50417,9.26723,3.08907-98.85039,63.326-135.91928C777.74563,192.72685,791.64646,186.5487,791.64646,175.73694Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#428591"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M816.35906,186.5487s33.97982,13.90083,46.33612,27.80167,64.87056,38.61343,64.87056,38.61343-4.63361,20.079-9.26722,20.079S807.09183,228.2512,796.28007,225.16213,791.64646,185.00416,816.35906,186.5487Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#428591"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M843.38846,157.97476s7.72269-7.72269-7.72269-13.90084c0,0,15.44538-6.17815,18.53445-15.44537s13.90084-24.7126,23.16806,0,26.25713,57.14788-29.34621,57.14788c0,0-13.90083,3.08907-13.90083-9.26722A23.16806,23.16806,0,0,1,843.38846,157.97476Z",
    transform: "translate(-84.96231 -101.26125)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICanFly);
export default __webpack_public_path__ + "static/media/iCanFly.1330f3a06ec18a2c269039c0ae54a314.svg";
export { ForwardRef as ReactComponent };